const FLOW_CHAT_QUERY_KEYS = {
  getSessions: 'flow-chat-sessions',
  getOneSession: 'flow-chat-one-session',
  getHistory: 'session-chat-history',
  getShareFlowChatSession: 'flow-chat-session-share'
} as const;

const FLOW_CHAT_EVENTS = {
  idle: 'idle',
  userMessage: 'message:user',
  messageStart: 'message:start',
  titleStart: 'title:start',
  titleDelta: 'title:delta',
  titleStop: 'title:stop',
  messageDelta: 'message:delta',
  messageStop: 'message:stop',
  complete: 'complete',
  error: 'error'
} as const;

const FLOW_CHAT_ANSWER_STATUS = {
  generating: 'generating',
  completed: 'completed'
} as const;

const SESSION_NAME_INPUT = 'sessionNameInput';

const SOURCE_TYPE = {
  predefined: 'predefined',
  none: 'none'
} as const;

export {
  FLOW_CHAT_QUERY_KEYS,
  FLOW_CHAT_EVENTS,
  FLOW_CHAT_ANSWER_STATUS,
  SESSION_NAME_INPUT,
  SOURCE_TYPE
};
